import { defineComponent as _defineComponent } from 'vue'
import {
  type MetricType,
  MetricReportingPeriodType,
  AnnualAggregationMethod,
} from '~/types/types'
import { renderMarkdown } from '~/functions/markdown'


export default /*#__PURE__*/_defineComponent({
  __name: 'MonthlyQuarterly',
  props: {
  metric: { type: Object as () => MetricType, required: true },
},
  setup(__props) {



return { __sfc: true,MetricReportingPeriodType, AnnualAggregationMethod, renderMarkdown }
}

})